









import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import StackedAreaScore from "./StackedAreaScore.vue";
import * as services from "@/services/analyses";
import { Analysis, YIELD_SCORE_TYPE} from "@/api/analyses/types";

@Component({
  name: "StackedAreaScoreController",
  components: {
    StackedAreaScore,
  },
})
export default class StackedAreaScoreController extends Vue {
  @Prop({ type: Object, required: true })
  private analysis!: Analysis;

  @Prop({ type: String, required: true })
  private harvestSeason!: string;

  @Prop({ type: String, required: true })
  private cropType!: string;

  @Prop({ type: String, required: true })
  private type!: string;

  @Prop({ type: String, required: false })
  private title!: string;

  private data: any = null;

  private loaded = false;

  private async mounted() {
    await this.loadChartData();
    this.loaded = true;
  }

  private async loadChartData() {
    this.$emit('update:loading', true);
    try {
      this.data = await services.findScoreAreaComparativeDataByAnalysis(
        this.analysis.uuid,
        this.harvestSeason,
        this.cropType,
        this.type
      );
      this.loaded = true;
    } finally {
      this.$emit('update:loading', false);
    }
  }

  get fetchKey() {
    return `${this.harvestSeason}:${this.cropType}`;
  }

  @Watch('fetchKey')
  private async onFetchKeyChange() {
    await this.loadChartData();
  }

  get getData() {
    return this.data;
  }

}
